import { REPORT_PATHS } from './reportPaths'

export const ROUTER_PATHS = {
  ORGANIZATION_PICKER: '/organization-picker',
  DASHBOARD: '/dashboard',
  PROJECTS: '/projects',
  PROJECT_DETAILS: '/projects/[id]',
  THREADS: '/threads',
  DYNAMIC_REMINDERS: '/dynamic-reminders',
  MY_TASKS: '/tasks',
  SEARCH: '/search',
  BOARDS: '/boards',
  TO_DO: '/todo',
  REPORTS: '/reports',
  PRODUCTION_PLANNING: '/production-planning',
  SIZE_MATRICES: '/size-matrices',
  COLLECTIONS: '/collections',
  COLLECTION_DETAILS: '/collections/[id]',
  TASK_DETAILS: '/tasks/[id]',
  RECURRING_TASK_DETAILS: '/tasks/recurrence/[id]',
  GOAL_DETAILS: '/goals/[id]',
  TODO_DETAILS: '/todo/[id]',
  BOARD_DETAILS: '/boards/[id]',
  ALL_TASKS_REPORT: `/reports/${REPORT_PATHS.ALL_TASKS}`,
  ALL_MILESTONES_REPORT: `/reports/${REPORT_PATHS.ALL_MILESTONES}`,
  LATE_TASKS_REPORT: `/reports/${REPORT_PATHS.LATE_TASKS}`,
  TIMELINE_REPORT: `/reports/${REPORT_PATHS.TIMELINE}`,
  TIME_TRACKING_REPORT: `/reports/${REPORT_PATHS.TIME_TRACKING}`,
  KEY_MILESTONES: `/reports/${REPORT_PATHS.KEY_MILESTONES}`,
  USAGE_REPORT: `/reports/${REPORT_PATHS.USAGE}`,
  SWITCH_ORGANIZATION: '/switch-organization',
  NOT_FOUND: '/404',
  SERVER_ERROR: '/500',
  ERROR: '/error',
  FORBIDDEN: '/forbidden',
  INVITATIONS: '/invitations',
  NOTIFICATIONS: '/notifications',
  GOOGLE_CALENDAR_AUTHORIZE: '/google-calendar',
  GOOGLE_EMAIL_AUTHORIZE: '/google-email',
  MICROSOFT_EMAIL_AUTHORIZE: '/microsoft-email',
  MICROSOFT_CALENDAR_AUTHORIZE: '/microsoft-calendar',
}
